import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import App from 'common/backbone-app';
import ROLES from 'common/constants/userRoles';

import {
  getConfigurablePermissionsByRoles,
  getConfigurableEmployeePermissions,
  getPersistedEmployee,
} from 'reduxStore/common/employees/selectors';
import * as actions from 'reduxStore/common/employees/actions';
import {
  canChangeRoleOrPermissions,
  resolveRolePermissionsDisableState,
} from 'components/employees/employeeEditPolicy';
import { getActorContext, getTargetEmployee } from 'components/employees/employeePolicyContext';
import EmployeePermissions from './index';

const mapStateToProps = (state) => {
  const {
    employees: {
      employee: { id, canLogin, emailAddress, role, supplierBound, active },
      isLoaded,
    },
  } = state;

  const pointOfSalePermissionsVisible = App.config.get('venue').pointOfSaleEnabled;
  const showTaxAuditorRole =
    App.config.get('venue').pointOfSaleEnabled || role === ROLES.TAX_AUDITOR;
  const selectedPermissions = getConfigurableEmployeePermissions(state, {
    pointOfSalePermissionsVisible,
  });
  const permissionsByRoles = getConfigurablePermissionsByRoles(state, {
    pointOfSalePermissionsVisible,
  });
  const showBasicRole = permissionsByRoles.find((i) => i.role === ROLES.BASIC) != null;
  const showAccessAttention = (!canLogin || id == null) && isLoaded;
  const actor = getActorContext();
  const persistedEmployee = getPersistedEmployee(state);
  const target = getTargetEmployee({
    id,
    role,
    persistedRole: persistedEmployee.role,
    permissions: selectedPermissions,
    supplierBound,
    active,
  });
  const roleChangePolicy = canChangeRoleOrPermissions(actor, target);
  const rolePermissionsDisableState = resolveRolePermissionsDisableState(
    emailAddress,
    roleChangePolicy,
  );

  return {
    id,
    role,
    isLoaded,
    selectedPermissions,
    permissionsByRoles,
    showAccessAttention,
    showTaxAuditorRole,
    showBasicRole,
    pointOfSalePermissionsVisible,
    actorPermissions: actor.permissions,
    actorRoleCode: actor.roleCode,
    masqueradingAsSupplier: actor.masqueradingAsSupplier,
    rolePermissionsDisabled: rolePermissionsDisableState.disabled,
    rolePermissionsDisableReason: rolePermissionsDisableState.reason,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

// @ts-expect-error ts-migrate(2345) FIXME: Type '{ id: null; role: null; selectedPermissions:... Remove this comment to see the full error message
export default connect(mapStateToProps, mapDispatchToProps)(EmployeePermissions);
